import React from 'react';
import { IonButton, useIonRouter } from '@ionic/react';

interface Props {
  streamId: string;
  cameraName: string;
}

const CameraCardButton: React.FC<Props> = ({ streamId, cameraName }) => {
  const router = useIonRouter();
  return (

    <IonButton
      expand="block"
      onClick={() =>
        router.push(`/movements/${streamId}/${encodeURIComponent(cameraName)}`, 'forward', 'push')
      }
      style={{ marginTop: 12 }}
    >
      Ver detalhes
    </IonButton>
  );
};

export default CameraCardButton;